import PropTypes from 'prop-types'
import { Button } from 'antd'
import { useStepIndex, useStepRunState, useStepActions } from './hooks/useSteps'

const RetryStepButton = ({ children = '重試', onClick, ...props }) => {
  const [currentStep] = useStepIndex()
  const { successStep } = useStepRunState()
  const { retryStep } = useStepActions()

  const handleClick = async (e) => {
    if (onClick) {
      onClick(e)
    }

    await retryStep()
  }

  if (successStep || currentStep === 0) {
    return null
  }

  return (
    <Button
      {...props}
      type='primary'
      size='large'
      onClick={handleClick}
    >
      {children}
    </Button>
  )
}

RetryStepButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  htmlType: PropTypes.string
}

export default RetryStepButton
